import api from "./api";
import offlineDb from "../db/appDb";

function toSafeView(view) {
  return String(view || "day").trim() || "day";
}

function toSafeDate(date) {
  return String(date || "").trim();
}

function toSafeScopeKey(scopeKey) {
  return String(scopeKey || "").trim() || "global";
}

export function createAgendaCacheKey({ scopeKey = "global", view = "day", date }) {
  return `${toSafeScopeKey(scopeKey)}:agenda:${toSafeView(view)}:${toSafeDate(date)}`;
}

export async function getCachedAgenda({ scopeKey = "global", view = "day", date }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const cacheKey = createAgendaCacheKey({ scopeKey: safeScopeKey, view, date });
  return offlineDb.agendaCache.get([safeScopeKey, cacheKey]);
}

export async function setCachedAgenda({ scopeKey = "global", view = "day", date, payload }) {
  const safeScopeKey = toSafeScopeKey(scopeKey);
  const cacheKey = createAgendaCacheKey({ scopeKey: safeScopeKey, view, date });
  const updatedAt = new Date().toISOString();

  const record = {
    scopeKey: safeScopeKey,
    cacheKey,
    view: toSafeView(view),
    date: toSafeDate(date),
    payload: payload || {},
    updatedAt,
  };

  await offlineDb.agendaCache.put(record);
  return record;
}

export async function fetchAgendaRemote({ scopeKey = "global", view = "day", date }) {
  const response = await api.get("/agenda/mine", {
    params: {
      view: toSafeView(view),
      date: toSafeDate(date),
    },
  });

  const payload = response?.data || {};
  const cacheEntry = await setCachedAgenda({ scopeKey, view, date, payload });

  return {
    payload,
    source: "remote",
    cachedAt: cacheEntry.updatedAt,
  };
}

export async function getAgendaWithOfflineCache({ scopeKey = "global", view = "day", date }) {
  try {
    return await fetchAgendaRemote({ scopeKey, view, date });
  } catch (error) {
    const cached = await getCachedAgenda({ scopeKey, view, date });
    if (cached) {
      return {
        payload: cached.payload || {},
        source: "cache",
        cachedAt: cached.updatedAt || null,
      };
    }

    throw error;
  }
}
